export const getWaiverTotal = (options, waiverPercentage, monthPrice) => {
    const prices =
        options?.map((option) => {
            const price = parseFloat(option?.option_price);

            if (option.qty) {
                if (option.addLinenCloth) {
                    const linenPrice =
                        option.option_linen_cloth_price * option.qty;
                    return price * option.qty + linenPrice;
                }

                return price * option.qty;
            }

            return price;
        }) || [];

    const totalOptionsPrice = prices.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
    );

    // Calculate the waiver amount
    const waiverAmount =
        (totalOptionsPrice + monthPrice) * (waiverPercentage / 100);

    return Math.ceil(waiverAmount);
};
